import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { CreditCard } from 'lucide-react';

const Billing = () => {
  return (
    <Card className="shadow-lg">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <CreditCard className="w-5 h-5" />
          Billing & Subscription
        </CardTitle>
        <CardDescription>
          Manage your subscription, payment method, and billing history
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="text-center py-12 text-gray-500 dark:text-gray-400">
          <CreditCard className="w-16 h-16 mx-auto mb-4 text-gray-300 dark:text-gray-600" />
          <p className="text-lg font-medium mb-2">Billing & Subscription</p>
          <p className="text-sm">View plan details, usage statistics, and payment history</p>
          <p className="text-xs mt-4">Coming soon in Phase 4</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default Billing;